const tableTransferFilter = (inputValue, item) => {
  const title = item.title.toLowerCase();
  const searchTerm = `${inputValue}`.toLowerCase();

  return title.indexOf(searchTerm) !== -1;
};
export default tableTransferFilter;
